module.exports = __webpack_public_path__ + "static/media/woodstock.6fca3a79.jpg";